import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Double from '../../../../java/lang/Double';
var MathUtil = /*#__PURE__*/function () {
  function MathUtil() {
    _classCallCheck(this, MathUtil);
  }
  _createClass(MathUtil, null, [{
    key: "log10",
    value: function log10(x) {
      var ln = Math.log(x);
      if (Double.isInfinite(ln)) return ln;
      if (Double.isNaN(ln)) return ln;
      return ln / MathUtil.LOG_10;
    }
  }, {
    key: "min",
    value: function min(v1, v2, v3, v4) {
      var min = v1;
      if (v2 < min) min = v2;
      if (v3 < min) min = v3;
      if (v4 < min) min = v4;
      return min;
    }
  }, {
    key: "clamp",
    value: function clamp() {
      if (typeof arguments[2] === 'number' && typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
        var x = arguments[0],
          min = arguments[1],
          max = arguments[2];
        if (x < min) return min;
        if (x > max) return max;
        return x;
      } else if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
        var _x = arguments[0],
          _min = arguments[1],
          _max = arguments[2];
        if (_x < _min) return _min;
        if (_x > _max) return _max;
        return _x;
      }
    }
  }, {
    key: "wrap",
    value: function wrap(index, max) {
      if (index < 0) return max - -index % max;
      return index % max;
    }
  }, {
    key: "max",
    value: function max() {
      if (arguments.length === 3) {
        var v1 = arguments[0],
          v2 = arguments[1],
          v3 = arguments[2];
        var max = v1;
        if (v2 > max) max = v2;
        if (v3 > max) max = v3;
        return max;
      } else if (arguments.length === 4) {
        var _v = arguments[0],
          _v2 = arguments[1],
          _v3 = arguments[2],
          v4 = arguments[3];
        var _max2 = _v;
        if (_v2 > _max2) _max2 = _v2;
        if (_v3 > _max2) _max2 = _v3;
        if (v4 > _max2) _max2 = v4;
        return _max2;
      }
    }
  }, {
    key: "average",
    value: function average(x1, x2) {
      return (x1 + x2) / 2.0;
    }
  }]);
  return MathUtil;
}();
export { MathUtil as default };
MathUtil.LOG_10 = Math.log(10);